import { render, staticRenderFns } from "./DeviceInfoPerformacePotencia.vue?vue&type=template&id=59100d66&"
import script from "./DeviceInfoPerformacePotencia.vue?vue&type=script&lang=js&"
export * from "./DeviceInfoPerformacePotencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports